/*
 * GrowthBook Feature Flags
 * Configuration for each flag can be found at: https://flagging.marty.zappos.com/features/<feature-name>
 */

export const FEATURE_SITE_REDESIGN = 'marty.site-redesign';
export const FEATURE_PTCT = 'ptct';
